export class Staff {
    id = null;
    voided = null;
    staffName = null;
    gender = null;
    birthDate = null;
    userName = null;
    // password = null;
    // confirmPassword = null;
    healthCareRoom = null;
    createKeycloakUser = null;
}